import { render, staticRenderFns } from "./rank.vue?vue&type=template&id=5a96ff6b&scoped=true"
import script from "./rank.vue?vue&type=script&lang=ts"
export * from "./rank.vue?vue&type=script&lang=ts"
import style0 from "./rank.vue?vue&type=style&index=0&id=5a96ff6b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a96ff6b",
  null
  
)

export default component.exports